import { LoadingButton } from '@mui/lab';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { ReactNode, useState } from 'react';

type ConfirmDialogProps = {
    title: string;
    content: string;
    children?: ReactNode;
    open: boolean;
    onClose: () => void;
    confirmButtonText?: string;
    handleCancel?: () => void;
    handleConfirm: () => Promise<void>;
};

const ConfirmDialog = ({
    title,
    content,
    children,
    confirmButtonText = 'Confirm',
    handleCancel,
    handleConfirm,
    ...props
}: ConfirmDialogProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const confirmHandler = () => {
        setIsLoading(true);
        handleConfirm().finally(() => {
            setIsLoading(false);
        });
    };

    return (
        <Dialog maxWidth="sm" fullWidth {...props}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <p>{content}</p>
                {children}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} variant="text" color="error">
                    Cancel
                </Button>
                <LoadingButton onClick={confirmHandler} variant="contained" loading={isLoading}>
                    {confirmButtonText}
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
